module.exports = __webpack_public_path__ + "img/dummyprod7@1x.c89898e7.png";